import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Button from '@material-ui/core/Button';

import Customtaskselect from './customtaskselect.js';

import '../../assets/css/customstyles.css'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export default function SimpleAccordion() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>CXR,Zwe Lyn,22</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <Customtaskselect></Customtaskselect>
          </Typography>
          <div>
          <Button variant="contained" color="primary" disableElevation className="tasklistbtn">
      Profile
    </Button>
    </div>
        </AccordionDetails>
      </Accordion>
     
    </div>
  );
}
